<template>
  <section class="page__slide about-page" tab-index="0">
    <main class="padded">
      <h1>About Me</h1>
      <p>
        Hi, My name is <strong>Poulami,</strong> and I am a product designer
        based out of India.
      </p>
      <p>
        While my job allows me the opportunity to apply my education, work and
        rational thinking to problems, my experiments are more about my impulses
        and love for learning new things.
      </p>
      <p>
        For now, that's all this space is for. In future, I may strive to create
        something bigger out of these projects. Or, maybe just continue to have
        fun.
      </p>

      <p>I don't know yet.</p>
    </main>
    <social-follow />
  </section>
</template>

<script>
import SocialFollow from '../childComps/SocialFollow.vue'
export default {
  components: {
    SocialFollow
  }
}
</script>

<style scoped>
.about-page {
  display: grid;
  align-items: top;
}
.about-page > * {
  grid-column: 1/ -1;
}
@media only screen and (min-width: 600px) {
  .about-page {
    grid-template-columns: 1fr fit-content(28rem);
  }
  .about-page > * {
    grid-column: auto;
  }
}
</style>
